import { UsersTab } from './UsersTab';
import { ROUTE_QUERY_PARAM } from '../../app/Routes/const';
import { Tabs, Tab } from '../../components';
import { OrganizationsTab } from './OrganizationsTab';
import { useTabPersistence } from '../../shared';

type TabsEnum = 'organizations' | 'users';
const USERS_AND_ORGANIZATIONS_TABS: TabsEnum[] = ['organizations', 'users'];

const UsersAndOrganizationsPage = () => {
  const { selectedTab, setSelectedTab } = useTabPersistence(
    {
      paramName: ROUTE_QUERY_PARAM.TAB,
      defaultTab: USERS_AND_ORGANIZATIONS_TABS[0],
      updateHistory: true,
    },
    USERS_AND_ORGANIZATIONS_TABS
  );

  return (
    <>
      <Tabs<TabsEnum>
        tabs={[
          { name: 'organizations', label: 'Organizations' },
          { name: 'users', label: 'Users' },
        ]}
        activeTab={selectedTab}
        onChange={setSelectedTab}
        contentClassName="mt-md"
      >
        <Tab name="organizations">
          <OrganizationsTab />
        </Tab>
        <Tab name="users">
          <UsersTab />
        </Tab>
      </Tabs>
    </>
  );
};

export default UsersAndOrganizationsPage;
